module.exports = __webpack_public_path__ + "static/media/printables.f876b781.svg";